'use strict';

angular.module('internal.inspections')
    .controller('InternalInspectionsTriggers', ['$scope', 'TGTriggerGroups', 'TGTriggers', function ($scope, TGTriggerGroups, TGTriggers) {
        $scope.loading = true;
        $scope.configuration = {
            infiniteFound: false
        };
        $scope.groups = [];
        //$scope.trigger_configuration = {};

         TGTriggerGroups.getConfiguration('Inspections').then(function (groups) {
             $scope.groups = groups;
             $scope.loading = false;
         })

        //($scope.reloadTriggerConfiguration = function() {
        //    $scope.loading = true;
        //    TGTriggerGroups.getConfiguration({code: 'Inspections', configurationCode: $scope.trigger_configuration.name}).then(function (groups) {
        //        $scope.groups = groups;
        //        $scope.loading = false;
        //    })
        //})()

        $scope.resetActions = function (trigger) {
            trigger.edit = false;
            trigger.trigger_action_values = angular.copy(trigger.previous_actions);
        }

        $scope.save = function (trigger, trigger_object_id) {
            trigger.saving = true;

            TGTriggers.save(trigger, trigger_object_id).then(function () {
                trigger.previous_actions = angular.copy(trigger.trigger_action_values);
                trigger.saving = false;
                trigger.edit = false;
            })
        }

        $scope.actionOptions = function (trigger, objectTrigger) {
            return {
                containment: '#trigger_' + (objectTrigger ? trigger.trigger_object_id : trigger.id),
                scrollableContainer: '#trigger_' + (objectTrigger ? trigger.trigger_object_id : trigger.id),
                containerPositioning: 'relative',
                accept: function (sourceItemHandleScope, destSortableScope) {
                    return sourceItemHandleScope.itemScope.sortableScope.$id === destSortableScope.$id;
                },
                orderChanged: function (event) {
                    trigger.edit = true;
                }
            };
        }

        //$scope.openConfigurationModal = function () {
        //    $scope.triggerRefresh = true;

        //    var modalInstance = $modal.open({
        //        animation: true,
        //        templateUrl: paths.app + 'inspections/components/trigger-configuration-modal/trigger-configuration-modal.html',
        //        controller: 'InternalInspectionTriggerConfigurationModal',
        //        size: 'lg'
        //    });

        //    modalInstance.result.then(function (trigger_configuration) {
        //        $scope.trigger_configuration.id = trigger_configuration.id;
        //        $scope.triggerRefresh = false;
        //    });
        //}
    }])
;